import { createSelector } from "@reduxjs/toolkit"

import { DepositMigrationStatus } from "#/shared/types"
import { getDepositMigrationStatus } from "#/shared/utils"

import { RootState } from "../reducers"

import { selectDeposits } from "./portal"

export const selectDepositActionId = (state: RootState) =>
  state.depositAction.id

export const selectDepositActionDepositId = (state: RootState) =>
  state.depositAction.depositId

export const selectDepositActionUserAmount = (state: RootState) =>
  state.depositAction.userAmount

export const selectDepositActionAmount = (state: RootState) =>
  state.depositAction.amount

export const selectDepositActionToken = (state: RootState) =>
  state.depositAction.token

export const selectDepositActionDailyMats = (state: RootState) =>
  state.depositAction.dailyMats

export const selectDepositActionType = (state: RootState) =>
  state.depositAction.actionType

export const selectDepositActionStatus = (state: RootState) =>
  state.depositAction.actionStatus

export const selectDepositActionLockEnd = (state: RootState) =>
  state.depositAction.lockEnd

export const selectDepositActionCurrentLockDuration = (state: RootState) =>
  state.depositAction.currentLockDuration

export const selectDepositActionNewLockDuration = (state: RootState) =>
  state.depositAction.newLockDuration

export const selectWithdrawalStep = (state: RootState) =>
  state.depositAction.withdrawalStep

export const selectDepositActionMigrationStatus = createSelector(
  selectDepositActionId,
  selectDeposits,
  (depositActionId, deposits) => {
    const depositFromStore = deposits.find(
      (deposit) => deposit.id === depositActionId,
    )

    if (!depositFromStore || !depositFromStore.migration)
      return DepositMigrationStatus.NotEligible

    return getDepositMigrationStatus(
      depositFromStore.token,
      depositFromStore.migration,
    )
  },
)
